module.exports = __webpack_public_path__ + "static/img/link-4.3b392a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/foot-view/link-4.jpg
// module id = VlVf
// module chunks = 8 9